import type { BookingSessionTypesListDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront/booking'

/** Key used to look up a session type on BookingSessionTypesListDto. */
export type SessionTypeKey = keyof BookingSessionTypesListDto

/**
 * Named constants for every SessionTypeKey.
 * Use these instead of raw string literals for type safety and discoverability.
 */
export const SessionType = {
  EliteUnlimited: 'eliteUnlimited',
  ElitePlus: 'elitePlus',
  Elite: 'elite',
  MostPopular: 'mostPopular',
  Legacy: 'legacy',
  LegacyRoadshowPlus: 'legacyRoadshowPlus',
  Standard: 'standard',
  StandardRoadshowPlus: 'standardRoadshowPlus',
  Simple: 'simple',
  SimpleRoadshowPlus: 'simpleRoadshowPlus',
  Basic: 'basic',
  BasicRoadshowPlus: 'basicRoadshowPlus',
  BasicPlus: 'basicPlus',
  BasicPlusRoadshowPlus: 'basicPlusRoadshowPlus',
  BasicMax: 'basicMax',
  BasicMaxRoadshowPlus: 'basicMaxRoadshowPlus',
  Mini: 'mini',
  MiniRoadshowPlus: 'miniRoadshowPlus',
  Essential: 'essential',
  EssentialRoadshowPlus: 'essentialRoadshowPlus'
} as const satisfies Record<string, SessionTypeKey>
